import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowBack,
  MdArrowForward,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Automate.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Automate({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeOperator,
  documents,
  tasks,
  connections,
  automations,
  setAutomations,
  setActiveContact,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [filteredExistingAutomations, setFilteredExistingAutomations] =
    useState([]);
  const [thisDay, setThisDay] = useState(Math.floor(Date.now() / 1000));
  let navigate = useNavigate();

  const handleClick = (operator) => {
    setActiveOperator(operator);
    navigate("/chats/0");
  };

  const getAutomationsForConnection = (connection) => {
    let helpArr = [];
    if (!isEmpty(automations)) {
      automations.map((automation, index) => {
        if (automation.connections_id == connection.id) {
          helpArr.push(automation);
        }
      });
    }
    return helpArr;
  };

  useEffect(() => {
    if (isEmpty(user)) {
      navigate("/login");
    }
    setActiveContact(null);
  }, [user]);

  const existingAutomations = [
    { title: "Email Antwort formulieren", if_case: "immer", then_case: "all" },
    { title: "Email Antwort senden", if_case: "immer", then_case: "all" },
    { title: "Email Angebot erstellen", if_case: "immer", then_case: "all" },
  ];

  useEffect(() => {
    if (!automations || !existingAutomations) return;

    const filtered = existingAutomations.filter(
      (existing) => !automations.some((auto) => existing.title == auto.title)
    );

    setFilteredExistingAutomations(filtered);
  }, [automations]);

  const createAutomation = async (
    title,
    connections_id,
    if_case,
    then_case
  ) => {
    if (isLoading) return;

    setIsLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("users_id", user.id);
    formData.append("connections_id", connections_id);
    formData.append("if_case", if_case);
    formData.append("then_case", then_case);

    try {
      const response = await fetch(
        apiURL + "/api/skills/createAutomation.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      setIsLoading(false);

      if (result.error) {
        console.error("Serverfehler:", result.error);
        return;
      }

      setAutomations((prev) => [...prev, result]); // Direkt mit spread
      console.log("Automation erstellt:", result);
    } catch (error) {
      setIsLoading(false);
      console.error("Fehler beim Senden:", error);
    }
  };

  return (
    <div className="automate">
      <div className="automate_topnav">
        <div className="automate_topnav_headline">Automatisierung</div>
        <div className="home_topnav_menubtn" onClick={() => navigate("/menu")}>
          <MenuIcon />
        </div>
      </div>
      <div className="automate_body">
        <div className="automate_body_active">
          <div className="automate_body_active_title">Aktiv</div>
          <div className="automate_body_active_list">
            {connections &&
              connections?.map((connection, index) => (
                <div className="automate_body_active_list_element">
                  <div
                    className="automate_body_active_list_element_title"
                    onClick={() => handleClick(operators[1])}>
                    {connection.email_adress}
                  </div>
                  {getAutomationsForConnection(connection).map(
                    (automation, index) => (
                      <div className="automate_body_active_list_element_automationsActive">
                        {automation.title} <CheckIcon />
                      </div>
                    )
                  )}
                  {filteredExistingAutomations.map((automation, index) => (
                    <div
                      className="automate_body_active_list_element_automations"
                      onClick={() =>
                        createAutomation(
                          automation.title,
                          connection.id,
                          automation.if_case,
                          automation.then_case
                        )
                      }>
                      {automation.title} {isLoading && <Spinner />}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
        <div className="automate_body_create">
          <div className="automate_body_create_title">
            Automatismus erstellen
          </div>
          <div className="automate_body_create_list">
            <div
              className="automate_body_create_list_element"
              onClick={() => handleClick(operators[1])}>
              <AddIcon /> Emails
            </div>
            <div
              className="automate_body_create_list_element"
              onClick={() => handleClick(operators[0])}>
              <AddIcon /> Termine
            </div>
            <div
              className="automate_body_create_list_element"
              onClick={() => handleClick(operators[0])}>
              <AddIcon /> Überweisungen
            </div>
            <div
              className="automate_body_create_list_element"
              onClick={() => handleClick(operators[0])}>
              <AddIcon /> Buchhaltung
            </div>
            <div
              className="automate_body_create_list_element"
              onClick={() => handleClick(operators[0])}>
              <AddIcon /> Erinnerungen
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowBackIcon = styled(MdArrowBack)`
  font-size: 15x;
  color: #717171;
`;

const ArrowForwardIcon = styled(MdArrowForward)`
  font-size: 15x;
  color: #717171;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #000000;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
